import { getWithLocaleFallback } from "../../services/strapiApi";

/**
 * Récupère une industrie spécifique par son slug
 */
export const fetchIndustryBySlug = async (slug) => {
  const result = await getWithLocaleFallback(
    `/industries?filters[slug][$eq]=${slug}&populate[metaImage][fields][0]=url&populate[metaImage][fields][1]=formats&populate[heroComponent][populate]=image&populate[sections][populate][0]=image&populate[sections][populate][1]=gallery&populate[contentBlocks][populate]=image&populate[domaine][populate]=icon&populate[caseStudies][populate]=*`
  );

  if (!result.ok) {
    return result;
  }

  const item = Array.isArray(result.data) ? result.data[0] : null;
  if (!item) {
    return {
      ok: false,
      reason: "NOT_FOUND",
      status: result.status,
      data: null,
      error: null,
    };
  }

  return { ...result, data: item };
};

/**
 * Récupère toutes les industries
 */
export const fetchAllIndustries = async ({ locale, fallbackLocale } = {}) => {
  const result = await getWithLocaleFallback(
    `/industries?populate[metaImage][fields][0]=url&populate[metaImage][fields][1]=formats&populate[heroComponent][populate]=image&populate[sections][populate][0]=image&populate[sections][populate][1]=gallery&populate[contentBlocks][populate]=image&populate[domaine][populate]=icon&populate[caseStudies][populate]=*`,
    { locale, fallbackLocale }
  );

  if (!result.ok) {
    return result;
  }

  return result;
};
